module.exports = __webpack_public_path__ + "1.4.15-unryo/img/varnish.ca96de76.svg";